// extracted by mini-css-extract-plugin
export default {"player":"PlayerInfo_player__lTMST","playerName":"PlayerInfo_playerName__YzRU5","boldFont":"PlayerInfo_boldFont__DaHxD"};